export async function backendAPI(data) {
  const response = await fetch(data.endPoint, data.body).catch(console.error)
  if(response === undefined || response === 'undefined'){
    return 500
  }else{
    const json = await response
    return json
  }
}
